export default __webpack_public_path__ + "static/media/mouse-up.58aa9060.ogg";